import { render, staticRenderFns } from "./AlertModule.vue?vue&type=template&id=4fa4e7d4"
import script from "./AlertModule.vue?vue&type=script&lang=js"
export * from "./AlertModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports